
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://zzrxarrnwzexonyhdbiq.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp6cnhhcnJud3pleG9ueWhkYmlxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzY0NzM4OTMsImV4cCI6MjA1MjA0OTg5M30.qBUS0L1S3-CJ3Z90UbevdDnDsyDRGvIl9NiqyS76Cjo";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
  global: {
    headers: {
      'Content-Type': 'application/json',
    },
  },
});
